import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import themeReducer from './slices/themeSlice';
import usersReducer from './slices/usersSlice';
import sessionReducer from './slices/sessionSlice';
import ordersReducer from './slices/ordersSlice';
import inventoryReducer from './slices/inventorySlice';
import posReducer from './slices/posSlice';
import adminSessionsReducer from './slices/adminSessionsSlice';
import auditReducer from './slices/auditSlice';
import offersReducer from './slices/offersSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    users: usersReducer,
    session: sessionReducer,
    orders: ordersReducer,
    inventory: inventoryReducer,
    pos: posReducer,
    adminSessions: adminSessionsReducer,
    audit: auditReducer,
    offers: offersReducer,
  },
});
